import { render } from "./DocumentsForm.vue?vue&type=template&id=1e9ab961&scoped=true&ts=true"
import script from "./DocumentsForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentsForm.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentsForm.vue?vue&type=style&index=0&id=1e9ab961&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ab961"],['__file',"resources/js/Components/DocumentsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e9ab961"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e9ab961', __exports__)) {
    console.log('reload')
    api.reload('1e9ab961', __exports__)
  }
  
  module.hot.accept("./DocumentsForm.vue?vue&type=template&id=1e9ab961&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1e9ab961', render)
  })

}


export default __exports__